import { useGlobalContextActions } from "@zenith/context/global-context/hooks";
import { REFRESH, ACCESS } from "@zenith/data/constants";
import { SIGN_IN } from "@zenith/routes/paths";
import {
  AuthenticationApiService,
  ApiResponseDTO,
} from "@zenith/services/user";
import { useState } from "react";
import Cookies from "js-cookie";
import { endPaygilantSession } from "@zenith/utils/paygilant";

// The user is signed out locally after this long even if the server has not answered
const SERVER_LOGOUT_TIMEOUT_MS = 5000;

/**
 * Ends the session on the server - the Keycloak session and the shared WEB/MOBILE
 * session slot - while the access token is still available to authorise the call.
 * Never throws: local sign-out must not depend on the server.
 */
async function endServerSession() {
  const refreshToken = sessionStorage.getItem(REFRESH);
  if (!refreshToken) return;

  const request = Promise.resolve(
    AuthenticationApiService.logoutV2({ refreshToken }, "WEB")
  ).catch(() => undefined);
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<void>((resolve) => {
    timer = setTimeout(resolve, SERVER_LOGOUT_TIMEOUT_MS);
  });
  try {
    await Promise.race([request, timeout]);
  } finally {
    clearTimeout(timer);
  }
}

export function HandleLogout() {
  const { clearAllContexts } = useGlobalContextActions();
  const [loggingOut, setLoggingOut] = useState<boolean>(false);
  const [userEmail, setUserEmail] = useState<string | null>(
    localStorage.getItem("userEmail")
  );

  async function handleLogout() {
    setLoggingOut(true);
    await endServerSession();

    sessionStorage.setItem("registrationModalShown", "false");
    sessionStorage.removeItem(REFRESH);
    sessionStorage.removeItem(ACCESS);
    localStorage.removeItem("userEmail");
    localStorage.removeItem("activeTab");
    Cookies.remove("ZENITH_ACCESS");
    endPaygilantSession();

    setUserEmail(null);
    clearAllContexts();
    // A full page load, not an in-app navigation: the Paygilant SDK only resets
    // its session when it loads.
    window.location.assign(SIGN_IN);
  }

  return { loggingOut, handleLogout };
}
